import { CheckCircle, Loader2 } from 'lucide-react';
import { StaticMetricCardAlt } from '@/components/StaticMetricCardAlt';
import { useFinancialWidgets } from '@/hooks/use-financial-widgets';
import { Card, CardContent } from '@/components/ui/card';

interface KpiActiveAssetsProps {
  readonly className?: string;
}

export function KpiActiveAssets({ className }: KpiActiveAssetsProps): React.ReactElement {
  const { useFinancialSummary } = useFinancialWidgets();
  const { data, isLoading } = useFinancialSummary();

  const activeCount = data?.activeAssets ?? 0;
  const totalCount = data?.totalAssets ?? 0;
  const percentage = totalCount > 0 ? ((activeCount / totalCount) * 100).toFixed(0) : '0';

  if (isLoading) {
    return (
      <Card className="overflow-hidden border-0">
        <CardContent className="p-6 h-[148px] flex flex-col items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
          <span className="text-sm text-muted-foreground mt-2">Loading...</span>
        </CardContent>
      </Card>
    );
  }

  return (
    <StaticMetricCardAlt
      title="Active Assets"
      value={activeCount.toLocaleString()}
      change={`${percentage}%`}
      changeLabel="of total"
      icon={CheckCircle}
      variant="info"
    />
  );
}
